<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2021-01-24 11:13 -->
<template>
  <div class="btn-block btn-group">
    <button
      @click="
        $emit('input', TYPES.DEFAULT);
        afterInput();
      "
      :class="{ active: value == TYPES.DEFAULT }"
      class="btn btn-primary btn-sm"
    >
      Para mesa
    </button>
    <button
      @click="
        $emit('input', TYPES.CARRY_OUT);
        afterInput();
      "
      :class="{ active: value == TYPES.CARRY_OUT }"
      class="btn btn-primary btn-sm"
    >
      Para llevar
    </button>
    <button
      @click="
        $emit('input', TYPES.DELIVERY);
        afterInput();
      "
      :class="{ active: value == TYPES.DELIVERY }"
      class="btn btn-primary btn-sm"
    >
      Para delivery
    </button>
  </div>
</template>
<script>
const TYPES = {
  DEFAULT: 1,
  CARRY_OUT: 2,
  DELIVERY: 3
};

export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    value: {
      //
    }
  },

  data: () => ({
    TYPES
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    afterInput() {
      setTimeout(() => {
        this.$emit("change");
      }, 300);
    }
  }
};
</script>

<style scoped></style>
